'use strict';
import _ from 'lodash'
import FeaturesStore from '../../modules/app/FeaturesStore'
import { bindShallow } from "../../uiMigration/bindAngularWithMobx";
import store from "../../modules/media/filters/MediaFiltersStore";
import SelectedLocationsStore from '../../services/locations/SelectedLocationsStore';
import * as mobx from "mobx";
import ProvidersStore from "../../services/providers/ProvidersStore";

angular.module('clientDashboardApp').controller("MediaCtrl",
    function ($scope, $location, $state, $uibModal, $timeout, mediaService, configService, reactContainer) {
        $scope.loadingResults = true;

        const userOptionsById = store.userOptions.reduce((sum, each) => ({...sum, [each.id]: each}), {});

        // some of the user options are mutually exclusive, keyed by their `exclusiveType` field.
        // This function compares the previous and the new state arrays,
        // and returns a new array of strings without the previous value
        const filterDistinctType = (previousOptionIds, optionIds) => {
          const added = _.difference(optionIds, previousOptionIds);
          const others = _.difference(optionIds, added);
          const addedTypes = added
            .map(x => userOptionsById[x])
            .filter(x => x && x.exclusiveType)
            .reduce((sum, x) => ({...sum, [x.exclusiveType]: true }), {});
          return others
            .map(x => userOptionsById[x] || { id: x })
            .filter(x => !x.exclusiveType || !addedTypes[x.exclusiveType])
            .map(x => x.id)
            .concat(added)

        };

        // sets various scope variable for comparing userOption changes in order to remove exclusive options
        function cleanUserOptions() {
          const previous = $scope.previousUserOptions || [];
          const current = $scope.searchConfig.userOptions || [];
          const distinct = filterDistinctType(previous, current);
          $scope.searchConfig.userOptions = $scope.previousUserOptions = distinct
        }

        $scope.userSettings = [];

        $scope.noteSettings = {
          usingTable: false,
          usingDeleteTooltip: true,
          idKey: "mediaId",
          noteType: "media",
          userInfo: $scope.userInfo,
          ready: false
        };

        $scope.searchConfig = {};


        let currentRequestId = 0;
        $scope.getReport = function () {
          $scope.loadingResults = true;
          $scope.lastRequested = new Date();
          $scope.noteSettings.ready = false;
          var mediaOptions = getMediaOptions();
          currentRequestId += 1;
          const requestId = currentRequestId;
          mediaService.mediaReport(mediaOptions, results => {
            if (currentRequestId === requestId) { // only allow latest request results through
              updateMediaList(results);
            }
          });
        };

        $scope.onFiltersUpdated = function () {

          cleanUserOptions();
          $scope.loadingResults = true;
          $scope.getReport();
        };

        $scope.setProvider = (provider) => {
          if (($scope.searchConfig.providers || []).join(",") !== provider) {
            $scope.searchConfig.providers = [provider];
          }
        }

        $scope.setGroupId = (id) => {
          SelectedLocationsStore.setLegacyGroupId(id);
        };

        configService.getBrandConfig(false, false).then(function (brandConfig) {
          $scope.brandConfig = brandConfig;
          $scope.workflow2Disabled = !FeaturesStore.workflow2Enabled
        });

        $scope.toggleThumbsUp = function(item){
          if(item.thumbRating == "positive"){
            item.thumbRating = "neutral";
          }
          else{
            item.thumbRating = "positive";
          }
          updateUserFeedback(item);
        }

        $scope.toggleThumbsDown = function(item){
          if(item.thumbRating == "negative"){
            item.thumbRating = "neutral";
          }
          else{
            item.thumbRating = "negative"
          }
          updateUserFeedback(item);
        }

        $scope.toggleStar = function(item){
          item.isStarred = !item.isStarred;
          updateUserFeedback(item);
        }

        function updateUserFeedback(item){
          mediaService.updateUserFeedback(item).then(function(resp){
            var responseItem = resp.data;
            let pageMediaItem = _.find($scope.pagingMediaItems,  (item) => {return responseItem.mediaId === item.mediaId})
            angular.copy(responseItem,  pageMediaItem)
          });
        }

        $scope.indLocSelected = function(){
          return $scope.searchConfig.groupId.search(/^legacy-/) >= 0;
        }


        $scope.$watch(function () {
          return $scope.searchConfig;
        }, function (newConfig, oldConfig) {
          onUpdated();
        }, true);

        const onUpdated = _.debounce(() => {
          $scope.onFiltersUpdated();
        }, 500)

        bindWithMobx();
        $scope.providers = mobx.toJS(ProvidersStore.providers.filter(x => x.dashboardSettings.media));

        function bindWithMobx() {
          $scope.$on("$destroy", mobx.reaction(
            () => SelectedLocationsStore.legacyGroupIdOrAll,
            groupId => $scope.searchConfig.groupId = groupId,
            {
              fireImmediately: true
            }
          ))
          bindShallow($scope, $scope.searchConfig, store.state, {
            initializeFromMobx: true,
          });

        }

        function getMediaOptions() {
          const userOptions = $scope.searchConfig.userOptions;
          const positive = userOptions.includes("positive");
          const negative = userOptions.includes("negative");
          const starred = userOptions.includes("starred");
          const businessPosted = userOptions.includes("businessPosted");
          const hasCaption = userOptions.includes("hasCaption");
          const userPosted = userOptions.includes("userPosted");

          const thumbRating = [ positive && 'positive', negative && 'negative'].filter(x => x);

          return {
            groupId: $scope.searchConfig.groupId,
            limit: 24,
            isStarred: starred || undefined,
            thumbRating,
            businessPosted: businessPosted !== userPosted ? businessPosted : undefined,
            hasCaption: hasCaption || undefined,
            providers: ($scope.searchConfig.providers.length ? $scope.searchConfig.providers : $scope.providers.map(x => x.id)).join(","),
            caption: ($scope.searchConfig.caption || "").trim() || undefined
          };
        }

        function updateMediaList(results) {
            reactContainer.getContainer().setState({totalNumber: results.totalResults});
            _.each(results.results,function(item){
              if(!item.thumbRating){
                item.thumbRating = "neutral";
              }
              if(!angular.isDefined(item.isStarred)){
                item.isStarred = false;
              }
            });
            $scope.pagingMediaItems = results;
            $scope.loadMoreResults = () => {
              if (!$scope.loadingResults) {
                return $scope.pagingMediaItems.loadMoreResults(24)
              } else {
                return null;
              }
            }
            $scope.loadingResults = false;
            $scope.noteSettings.ready = true;
        }

        $scope.zoomImage = function(mediaItem) {
            $scope.selectedItem = mediaItem;
            var zoomModal = $uibModal.open({
              template: require('./zoomImageModal.html'),
              controller: 'zoomImageController',
              scope: $scope,
              size: 'lg'
            });
        }

        $scope.hasMoreResults = function (searchResult) {
          if (!searchResult) {
            return;
          }
          return searchResult.hasMoreResults();
        };

        $scope.hasAnyResults = function (searchResult) {
          return typeof searchResult !== "undefined" ? searchResult.hasAnyResults() : false;
        };

        $scope.selectAllProviders = () => {
          $scope.searchConfig.providers = _.map($scope.providers, p=> p.id);
        }
    });
